import * as React from "react";
import Spinner from "../Spinner";
import "./styles.css";

interface IProps {
  isLoading: boolean;
}

const LoadingOverlay: React.SFC<IProps> = props => {
  if (!props.isLoading) {
    return null;
  }

  return (
    <div className="loading-overlay">
      <Spinner />
    </div>
  );
};

export default LoadingOverlay;



// WEBPACK FOOTER //
// ./src/components/loading-overlay/index.tsx